import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { ROUTES } from "@/routes";

export function RoleRedirect() {
  const { user, role, loading } = useAuth();
  const [checkingOnboarding, setCheckingOnboarding] = useState(true);
  const [needsProviderOnboarding, setNeedsProviderOnboarding] = useState(false);
  const [needsMemberOnboarding, setNeedsMemberOnboarding] = useState(false);

  useEffect(() => {
    async function checkOnboarding() {
      if (!user || !role) {
        setCheckingOnboarding(false);
        return;
      }

      if (role === "provider") {
        const { data } = await (supabase as any)
          .from("providers")
          .select("id")
          .eq("user_id", user.id)
          .maybeSingle();

        setNeedsProviderOnboarding(!data);
      } else if (role === "member") {
        const { data } = await (supabase as any)
          .from("patients")
          .select("id")
          .eq("user_id", user.id)
          .maybeSingle();

        setNeedsMemberOnboarding(!data);
      }

      setCheckingOnboarding(false);
    }

    if (!loading && user && role) {
      checkOnboarding();
    } else if (!loading) {
      setCheckingOnboarding(false);
    }
  }, [user, role, loading]);

  if (loading || checkingOnboarding) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.AUTH} replace />;
  }

  if (role === "provider") {
    return needsProviderOnboarding
      ? <Navigate to={ROUTES.PROVIDER_ONBOARDING} replace />
      : <Navigate to={ROUTES.PROVIDER} replace />;
  } else if (role === "billing") {
    return <Navigate to={ROUTES.BILLING} replace />;
  } else if (role === "member") {
    return needsMemberOnboarding
      ? <Navigate to={ROUTES.MEMBER_ONBOARDING} replace />
      : <Navigate to={ROUTES.MEMBER} replace />;
  }

  return <Navigate to={ROUTES.MEMBER} replace />;
}
